import {connect} from 'react-redux';
import Form_10 from './Form_10';
import {submitStep} from '../../actions/steps/submitStep';
import {updateCalcWeights} from '../../actions/steps/updateCalcWeights';
import {getShumaStepStatus} from '../../actions/steps/getShumaStepStatus';
import {
  showGlobalErrorMessage
} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';
import {getStepData} from '../../actions/steps/getStepData';

const mapStateToProps = ({
                           stepData: {stepData},
                           shumaProperties: {shumaTypeID}
                         }) => ({
  stepData,
  shumaTypeID
});

export default connect(
  mapStateToProps,
  {submitStep, updateCalcWeights, getShumaStepStatus, showGlobalErrorMessage, getStepData}
)(Form_10);
